import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CompanyPartner } from '@interfaces/common/company';
import { Option } from '@interfaces/common/option';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { VaultBaseComponent } from '@src/app/shared/components/base/vault-base.component';
import { DialogComponent } from '@src/app/shared/components/dialog/dialog.component';
import { SharedModule } from '@src/app/shared/shared.module';
import { AppState } from '@src/app/state';
import { RFB_QUALIFICATIONS } from '../constants/company-qualifications.constants';

@Component({
  selector: 'app-company-partner-modal',
  standalone: true,
  templateUrl: './company-partner-modal.component.html',
  styleUrls: ['./company-partner-modal.component.scss'],
  imports: [CommonModule, FormsModule, SharedModule],
})
export class CompanyPartnerModalComponent extends VaultBaseComponent {
  @Output() confirmed = new EventEmitter<CompanyPartner>();

  @ViewChild('dialog') dialogRef: DialogComponent | null = null;

  isEditMode = false;
  name = '';
  qualification: string | null = null;
  countryOfOrigin = '';
  legalRepresentativeName = '';
  legalRepresentativeQualification = '';

  qualificationOptions: Option[] = RFB_QUALIFICATIONS;

  private companyId = '';
  private editingPartner: CompanyPartner | null = null;

  constructor(translateService: TranslateService, store: Store<AppState>) {
    super(translateService, store);
  }

  private normalizeQualification(value: string | null | undefined): string | null {
    if (!value) return null;
    if (this.qualificationOptions.some(opt => opt.value === value)) return value;
    const codeMatch = value.match(/^(\d+)/);
    if (codeMatch) {
      const code = codeMatch[1].padStart(2, '0');
      const found = this.qualificationOptions.find(opt =>
        (opt.value as string).startsWith(code + ' - ')
      );
      if (found) return found.value as string;
    }
    return value;
  }

  open(partner: CompanyPartner | null, companyId: string): void {
    this.companyId = companyId;
    this.editingPartner = partner;
    this.isEditMode = !!partner;

    if (partner) {
      this.name = partner.name;
      this.qualification = this.normalizeQualification(partner.qualification);
      this.countryOfOrigin = partner.countryOfOrigin ?? '';
      this.legalRepresentativeName = partner.legalRepresentativeName ?? '';
      this.legalRepresentativeQualification = partner.legalRepresentativeQualification ?? '';
    } else {
      this.name = '';
      this.qualification = null;
      this.countryOfOrigin = '';
      this.legalRepresentativeName = '';
      this.legalRepresentativeQualification = '';
    }

    this.dialogRef?.open('', '', '', 'Cancelar', '', 'company-partner-modal', false, true);
  }

  isFormValid(): boolean {
    return !!this.name?.trim() && !!this.qualification;
  }

  submitAction(): void {
    if (!this.isFormValid()) return;

    const partner: CompanyPartner = {
      id: this.editingPartner?.id ?? null,
      companyId: this.companyId,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      company: this.editingPartner?.company as any,
      name: this.name.trim(),
      qualification: this.qualification!,
      countryOfOrigin: this.countryOfOrigin,
      legalRepresentativeName: this.legalRepresentativeName,
      legalRepresentativeQualification: this.legalRepresentativeQualification,
    };

    this.confirmed.emit(partner);
    this.dialogRef?.close();
  }
}
